<template>
  <SwapMenu2 :swapid="swapid" :title="title" margin="2">
     <template v-slot:menu>
       <li><a class="dropdown-item" @click="clearframe()">Clear Area</a></li>
       <li><a class="dropdown-item" @click="runcmd('dfspace.sh')">Space (df)</a></li>
       <li><a class="dropdown-item" @click="runcmd('top.sh')">Process (top)</a></li>
       <li><a class="dropdown-item" @click="swapinfo()">This Swap Info</a></li>
     </template>
  </SwapMenu2>
  <iframe :id="globid" style="width: 100%;height:100%">
  </iframe>
</template>

<script>
   import SwapMenu2 from './SwapMenu2.vue' 
   import axios from 'axios' 
   export default {
        name : 'IframeArea',
        components : {
            SwapMenu2
        },
        props: {
            swapid : String,
            globid : String
        },
        computed: {
        },
        data() { return { state: this.$store.state,
                          title: "Display Area", 
                          mydata: "unmounted",
                          cmdstat: "start" 
                          } },
        methods: {
            clearframe() {
                let frame1 = document.getElementById(this.globid);
                let myframe = frame1.contentWindow.document;
                myframe.write ("<pre></pre>");
                myframe.close();
            },
            writearea(s) {
                let frame1 = document.getElementById(this.globid);
                let myframe = frame1.contentWindow.document;
                myframe.write (s);
                myframe.close();
            },
            swapinfo() {
                this.$store.state.rootel.swapinfo(this.swapid) ;
            },
            runcmd(cmd, argument = "") {    // toggle start or stop swap
                this.writearea ("Please Wait Excecuting " + cmd + " ...") ;
                let req = "" ;
                try {
                    req = this.$store.getters.controller_url +
                    "/prosw/exec/x/" + cmd + "?" + "swapid=" + 
                    this.swapid + "&argument=" + argument ;
                }
                catch(err) {
                    console.log(err) ;
                    return ;
                }
                axios.get (req,  {
                    timeout: 20000,
                    responseType: 'text', 
                    headers: {'Pswtoken': this.$store.getters.pswtoken }
                }).then ( (response) => {
                  let res = response.data ;
                  if (typeof res == "object")
                    this.writearea(JSON.stringify(res)) ;
                  else 
                    this.writearea("<pre>" + response.data + "</pre>") ;
                  }
                ).catch ( (error) => { 
                    this.writearea ("REQUEST TIMEMOUT") ;
                    if (error.code === 'ECONNABORTED') 
                       console.log('Request timed out');
                    else 
                       console.log(error.message);
                })
            }
        },
        mounted() {
            this.runcmd('dfspace.sh') ;
        },
        created() {
            this.mydata = "created";
            console.log ("home view created") ;
        },
        setup() {
           console.log ("home view setup") ;
        }
   }
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

